const selectorsFeth = {
  customFetchBtn: '.custom-fetch',
}

const button = document.querySelector(selectorsFeth.customFetchBtn);

// Function to clear the cart
function clearCartInterval() {
  fetch('/cart/clear.js?requestType=ajax', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart is now cleared', data);
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
}

function addToCart(event) {
  if (!button) { return; }
  button.removeEventListener('click', clearCart);

  setTimeout(() => {
    event.stopPropagation();
    button.click();
  }, 1000);
}

function clearCart(event) {
  event.preventDefault();
  clearCartInterval();
  addToCart(event);
}

function setEventListeners() {
  if (!button) { return; }
  button.addEventListener('click', clearCart);
  console.log('cart event set');
}

document.addEventListener('DOMContentLoaded', () => {
  setEventListeners();
  console.log('DOM fully loaded and parsed');
});



window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    clearCartInterval();
    setEventListeners();
    console.log('Page loaded from back/forward cache');
  }
});

let checkCartInterval = setTimeout(clearCartInterval, 500);